












import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Account } from '@/modules/Account/interfaces/account'
import S3Handler from '@/mixins/s3'
import AppAttachmentsCard from '@/components/AppAttachmentsCard.vue'

@Component({
  components: {
    AppAttachmentsCard
  }
})
export default class AccountDetailContact extends mixins(S3Handler) {
  @Prop({ type: Object as () => Account }) readonly account!: Account

  get attachmentList () {
    return this.account.attachments || []
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }
}
